"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var isEmptyString_1 = __importDefault(require("./isEmptyString"));
/**
 * Provided a string, will return the string split on spaces, commas,
 * semicolons, tabs, or new lines
 */
var parseSeparatedList = function (list) {
    return list.split(/[\s,;\t\n]+/).filter(lodash_1.negate(isEmptyString_1.default));
};
exports.default = parseSeparatedList;
